import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Content from './content';
import Header from './header';
import BottomFooter from './footer';
import ToTop from '../../components/toTop';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { search, footer, columnData, newsstream, columnId, isEnd, mainData, originalAside } = content;
        const { logo, QRCode, title, description, qr_title } = columnData;

        const headerData = {
            search,
            logo,
            // domain,
            // breadCrumbdata,
        };

        const columnIntroData = {
            logo,
            QRCode,
            title,
            description,
            qr_title
        };

        const contentData = {
            columnIntroData,
            newsstream,
            columnId,
            isEnd,
            mainData,
            originalAside,
        };

        const footerData = {
            footer,
        };

        return (
            <div>
                <Header content={headerData} />
                <Content content={contentData} />
                <BottomFooter content={footerData} />
                <ToTop />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default Layout;
